import Overlay from './src/overlay'

export const JdOverlay = Overlay
export default JdOverlay

export * from './src/overlay'
